if(!customElements.get('collection-layout')) {
  class CollectionLayout extends HTMLElement {
    constructor() {
      super();
      var grids = document.querySelectorAll('.collection-grid');
      var inputs = document.querySelectorAll('.collection-utils input[name="grid-layout"]');
      var saveAttribute = $s.debounce(function(layout) {
        $s.post({type: 'POST', url: '/cart/update.js', data: {attributes: {'_grid_layout': layout}}, dataType: 'json'});
      }, 1000);
      this.setOptionByCookie = function() {
        var layout = Cookies.get(getCookieKey());
        var input = layout ? document.querySelector('.collection-utils input[name="grid-layout"][value="'+layout+'"]') : null;
        updateLayout(input);
      }
      function updateLayout(selectedOption) {
        if (!selectedOption) {
          if (grids[0]) {
            grids.forEach(x=>{x.removeAttribute('data-grid-layout')});
            var ipr = (window.getComputedStyle(grids[0]).getPropertyValue('--items-per-row')||'').trim();
            inputs.forEach(input=>{
              if (input.dataset.value == ipr && $s.isVisible(input)) {
                selectedOption = input;
              }
            });
          }
        }
        var layout = (selectedOption ? selectedOption.value : '');
        if (layout) {
          selectedOption.checked = true;
          grids.forEach(x=>{x.setAttribute('data-grid-layout', layout)});
          Cookies.set(getCookieKey(), layout, { expires: 7 });
        }
        if (prevLayout!=layout) {
          saveAttribute(layout);
          prevLayout = layout;
        }

        window.dispatchEvent(new CustomEvent('resize')); //trigger event resize to update images and any other feature that depends on product card size.
      }
      function getCookieKey() {
        return 'grid_layout_' + ($s.media.isSmall ? 's' : ($s.media.isMedium ? 'm' : 'l'))
      }
      inputs.forEach(input=>{
        input.addEventListener('change', (e)=>{updateLayout(input);});
        input.removeAttribute('disabled');
      });
      var prevLayout = Cookies.get(getCookieKey());
      this.setOptionByCookie();
    }

    connectedCallback() {
      window.addEventListener('mediaChange', this.setOptionByCookie);
    }

    disconnectedCallback() {
      window.removeEventListener('mediaChange', this.setOptionByCookie);
    }
  }
  customElements.define('collection-layout', CollectionLayout);
}

if(!customElements.get('collection-filters') && !customElements.get('collection-filters-tags')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.form = this.querySelector('form');
      this.summary = this.querySelector('.summary');
      this.summaryBottom = this.querySelector('.summary-bottom');
      this.documentClickHandler = this.documentClick.bind(this);
      this.ajax = true;

      if(this.dataset.open) {
        this.showFilters();
      }
      if(this.form){
        this.form.addEventListener('submit', (e)=>{
          e.preventDefault();
        });
      }
      if(this.pageManager){
        this.pageManager.querySelectorAll('.open-filters').forEach(x=>{
          x.addEventListener('click', ()=>{
            this.showFilters();
          });
        });
      }
      if(this.querySelector('.close-filters')){
        this.querySelector('.close-filters').addEventListener('click', ()=>{
          this.hideFilters();
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
    }

    documentClick(e) {
      if(!this.contains(e.target)) {
        this.hideFilters();
      }
    }

    isOpen() {
      return this.classList.contains('open');
    }

    showFilters() {
      $s.closeModal();
      $s.showOverlay();
      this.classList.add('open');
      $s.trapFocus(this);
      setTimeout(()=>{
        document.addEventListener('click', this.documentClickHandler);
      }, 100);
    }

    hideFilters() {
      $s.hideOverlay();
      this.classList.remove('open');
      $s.removeTrapFocus();
      document.removeEventListener('click', this.documentClickHandler);
    }
  }

  if(!customElements.get('collection-filters')) {
    class CollectionFilters extends CollectionFiltersAbstract {
      constructor() {
        super();

        this.querySelectorAll('input:not([name=sort])').forEach((option)=>{
          option.addEventListener('change', (e)=>{
            this.filterResults();
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  this.querySelectorAll('.group input').forEach((element)=>{
                    element.value = '';
                    element.checked = false;
                  });
                } else {
                  (this.querySelector('#'+button.dataset.optionId) || {}).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
        if(this.summaryBottom) {
          this.summaryBottom.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  this.querySelectorAll('.group input').forEach((element)=>{
                    element.value = '';
                    element.checked = false;
                  });
                } else {
                  (this.querySelector('#'+button.dataset.optionId) || {}).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
      }

      // getSearchParams() {
      //   const formData = new FormData(this.form);
      //   const searchParams = new URLSearchParams(formData);

      //   var params = new URLSearchParams();
      //   const keys = Array.from(searchParams.keys()).filter((x, i, a) => a.indexOf(x)==i);
      //   keys.forEach((key)=>{
      //     let values = searchParams.getAll(key);
      //     if(values.find(x=>x!="")) {
      //       params.set(key, values.join(','));
      //     }
      //   });

      //   var currenSearch = new URLSearchParams(location.search);
      //   if(currenSearch.has('sort_by')) {
      //     params.set('sort_by', currenSearch.get('sort_by'));
      //   }

      //   return params;
      // }

      getSearchParams() {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams();
        
        const keys = Array.from(formData.keys()).filter((x, i, a) => a.indexOf(x) == i);
      
        keys.forEach((key) => {
          let values = formData.getAll(key);
          values.forEach((value) => {
            if (value !== "") {
              searchParams.append(key, value);
            }
          });
        });
      
        const currentSearch = new URLSearchParams(location.search);
        if (currentSearch.has('sort_by')) {
          searchParams.set('sort_by', currentSearch.get('sort_by'));
        }
      
        return searchParams;
      }

      filterResults() {
        var url;
        var params = this.getSearchParams();
        var paramsString = params.toString().replace(/%2C/g, ',');
        if(this.ajax) {
          $s.showLoadingOverlay();
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            if (document.querySelector(this.pageManager.dataset.itemsContainerSelector)) {
              var newTop = document.querySelector(this.pageManager.dataset.itemsContainerSelector).offsetTop - document.getElementById('header').offsetHeight - 80
              if (newTop<60) {
                newTop = 0;
              }
              window.scrollTo(0, newTop);
            };
            setTimeout(() => {
              document.getElementById("show-hide-filters").onclick = function() {myFunction()};
    
              function myFunction() {
                console.log("FRANKERINOUUU")
                if( document.querySelector("collection-filters").classList.contains("hide")){
                  document.querySelector("collection-filters").classList.remove("hide");
                  document.querySelector("#show-hide-filters span").innerHTML = "Hide Filters";
                }else{
                  document.querySelector("collection-filters").classList.add("hide");
                  document.querySelector("#show-hide-filters span").innerHTML = "Show Filters";
                }
              }
            }, 500);
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              doc.querySelector('.collection-filters').dataset.open = true;
            }
            $s.hideLoadingOverlay();
          });
        } else {
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          location = url;
        }
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  if(!customElements.get('collection-filters-tags')) {
    class CollectionFiltersTags extends CollectionFiltersAbstract {
      constructor() {
        super();
        this.baseUrl = location.origin + this.dataset.baseUrl;

        this.querySelectorAll('.item a').forEach((link)=>{
          link.addEventListener('click', (e)=>{
            e.preventDefault();
            this.filterResults(link.href);
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.clearAll) {
                var url = new URL(this.baseUrl);
                var currentUrl = new URL(location.href);
                url.search = currentUrl.search;
                this.filterResults(url.toString());
              } else {
                this.querySelector('#'+button.dataset.optionId).closest('a').dispatchEvent(new Event('click', {bubbles: true}));
              }
            });
          });
        }
      }

      filterResults(url) {
        if(this.ajax) {
          $s.showLoadingOverlay();
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              doc.querySelector('.collection-filters').dataset.open = true;
            }
          });
        } else {
          location = url;
        }
      }
    }
    customElements.define('collection-filters-tags', CollectionFiltersTags);
  }

  if(!customElements.get('price-range-filter')) {
    class PriceRangeFilter extends HTMLElement {
      constructor() {
        super();
  
        const rangeInput = this.querySelectorAll('.range-input input');
        const priceInput = this.querySelectorAll('input[type="number"]');
        const range = this.querySelector('.price-progress .line');
        let priceGap = 0;
  
        priceInput.forEach((input, ix) =>{
            input.addEventListener('input', e =>{
                handleZIndex(ix);
                let minPrice = parseFloat(priceInput[0].value);
                let maxPrice = parseFloat(priceInput[1].value);
                
                if((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max){
                    if(e.target.classList.contains('input-min')){
                        rangeInput[0].value = minPrice;
                        range.style.left = ((minPrice / rangeInput[0].max) * 100) + '%';
                    }else{
                        rangeInput[1].value = maxPrice;
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + '%';
                    }
                }
            });
        });
  
        function handleZIndex(activeInputIndex) {
          rangeInput.forEach((input,ix)=>{
            input.style.zIndex = activeInputIndex!=ix ? '' : '1';
          });
        }
  
        rangeInput.forEach((input, ix) =>{
            input.addEventListener('input', e =>{
                let minVal = parseFloat(rangeInput[0].value);
                let maxVal = parseFloat(rangeInput[1].value);
                handleZIndex(ix);
  
                if((maxVal - minVal) < priceGap){
                    if(e.target.classList.contains('range-min')){
                        rangeInput[0].value = maxVal - priceGap
                    }else{
                        rangeInput[1].value = minVal + priceGap;
                    }
                }else{
                    priceInput[0].value = minVal;
                    priceInput[1].value = maxVal;
                    range.style.left = ((minVal / rangeInput[0].max) * 100) + '%';
                    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
                }
            });
        });
  
        function init() {
          let minVal = parseFloat(rangeInput[0].value);
          let maxVal = parseFloat(rangeInput[1].value);
          range.style.left = ((minVal / rangeInput[0].max) * 100) + '%';
          range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
  
          if (rangeInput[0].value==rangeInput[0].max) {
            //bring range-min to front
            handleZIndex(0);
          }
        }
        init();
      }
  
      
    }
    customElements.define('price-range-filter', PriceRangeFilter);
  }
  
}

if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      //this.dropdown = this.querySelector('#sort-by');
      this.sortItems = this.querySelectorAll('input[name=sort]');
      this.ajax = true;

      var search = new URLSearchParams(location.search)
      //this.dropdown.value = search.get('sort_by') || this.dataset.sortBy;
      this.sortItems.forEach(sortitem => {
        sortitem.addEventListener('click', ()=>{
          var search = new URLSearchParams(location.search); //get new instance
          search.set('sort_by', sortitem.value);
          search.delete('page');
          var paramsString = search.toString();
          paramsString = paramsString.replace(/%2C/g,',');
          if(this.ajax) {
            $s.showLoadingOverlay();
            const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
            this.pageManager.loadPage(url, ()=>{
              $s.hideLoadingOverlay();
              setTimeout(() => {
                var html = document.querySelector('html');
                html.classList.remove('show-overlay');
              }, 100);
            });
          } else {
            location.search = paramsString;
          }
        });
      });

      /*this.dropdown.addEventListener('change', ()=>{
        var search = new URLSearchParams(location.search); //get new instance
        search.set('sort_by', this.dropdown.value);
        search.delete('page');
        var paramsString = search.toString();
        paramsString = paramsString.replace(/%2C/g,',');
        if(this.ajax) {
          $s.showLoadingOverlay();
          const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
            setTimeout(() => {
              var html = document.querySelector('html');
              html.classList.remove('show-overlay');
            }, 100);
          });
        } else {
          location.search = paramsString;
        }
      });*/
    }
  }
  customElements.define('collection-sort', CollectionSort);
}


if(!customElements.get('collection-active-filters')) {
  class collectionActiveFilters extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');

      this.querySelectorAll('button').forEach(button => {
        button.addEventListener('click',() => {
          if(button.hasAttribute('data-clear-all')){
            this.pageManager.querySelector(`[type="button"][data-clear-all="true"]`).click();
          }else{
            this.pageManager.querySelector(`[type="button"][data-option-id="${button.dataset.optionId}"]`).click();
          }
        });
      });
    }
  }
  customElements.define('collection-active-filters', collectionActiveFilters);
}